import React, { useEffect, useRef, useState } from "react";
import SplitPane from "react-split-pane";
import Pane from "react-split-pane/lib/Pane";
import { useDispatch, useSelector } from "react-redux";
import { fetchDocument } from "slices/dictionarySearch/actions/categories";
import Categories from "layout/dictionarySearch/document/categories";
import ContentPanel, {
  getDocItemsArrayList,
} from "layout/dictionarySearch/content/ContentPanel";

const DictionarySearchDocument = () => {
  const dispatch = useDispatch();
  const categoriesListRef = useRef();
  const [categoriesSize, setCategoriesSize] = useState("430px");
  const documents = useSelector((state) => state.dictionarySearch.documents);

  const handleDragRelease = () => {
    if (categoriesListRef && categoriesListRef.current) {
      setCategoriesSize(categoriesListRef.current.props.size);
    }
  };
  const styles = {
    background: "transparent",
    width: "1px",
    cursor: "col-resize",
    height: "100%",
    paddingRight: "2px",
    borderRight: "transparent 4px solid",
    borderLeft: "transparent 4px solid",
    margin: "0 -5px",
    zIndex: "1",
  };

  useEffect(() => {
    dispatch(fetchDocument());
    window.addEventListener("mouseup", handleDragRelease);
    return () => {
      window.removeEventListener("mouseup", handleDragRelease);
    };
  }, [dispatch]);

  return (
    <SplitPane
      className="dictionary_search__document"
      style={{ position: "relative", overflow: "hidden" }}
      resizerStyle={styles}
      split="vertical"
      data-testid="dictionary-search-document"
    >
      <Pane
        ref={categoriesListRef}
        minSize="220px"
        initialSize={categoriesSize}
        className="dictionary_search__document-left"
      >
        <Categories />
      </Pane>
      <Pane minSize="200px" className="dictionary_search__document-right">
        <ContentPanel docItemsArray={getDocItemsArrayList(documents)} docView />
      </Pane>
    </SplitPane>
  );
};

export default DictionarySearchDocument;
